import { SVGProps } from "react";

export const ArrowDownRed = ({
  color = "currentColor",
  size = "14",
  ...props
}: { color?: string; size?: string } & SVGProps<SVGSVGElement>) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.39802 9.0932L12.25 10.5L11.0423 5.59466L9.53578 7.04095L7.10561 4.50952C7.02311 4.42358 6.90913 4.375 6.79 4.375C6.67087 4.375 6.55689 4.42358 6.47439 4.50952L4.69 6.36826L2.06561 3.63452C1.89827 3.46021 1.62132 3.45456 1.44702 3.62189C1.27271 3.78923 1.26706 4.06618 1.43439 4.24048L4.37439 7.30298C4.45689 7.38892 4.57087 7.4375 4.69 7.4375C4.80913 7.4375 4.92311 7.38892 5.00561 7.30298L6.79 5.44424L8.90457 7.64691L7.39802 9.0932Z"
      fill={color}
    />
  </svg>
);
